export const iconFontAwesomeSpinnersRing = (
	<i className="fa-solid fa-ring"></i>
);
